import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import {
  BrowserRouter,
  Route,
  Switch,
  StaticRouter,
  Redirect,
} from "react-router-dom";
import jwtDecode from "jwt-decode";
import AuthRoute from "../../utils/AuthRoute";
import RouteWithNavElements from "../../utils/RouteWithNavElements";
import RouteWithOptionalNavElements from "../../utils/RouteWithOptionalNavElements";
import webApplicationSchema from "../../schema/webApplicationSchema.json";

import axios from "axios";
import {
  validateFBIdToken,
  refreshFBIdToken,
} from "../../utils/validateIdToken";
import config from "../../utils/config";
import { startPinterestOAuth } from "../../utils/utilityFunctions";

// Redux
import { Provider } from "react-redux";
import {
  SET_AUTHENTICATED,
  SET_BATCH_CONTENT_LOADING,
} from "../../redux/types";
import {
  getUserData,
  refreshPinterestAccessToken,
  softLogoutUser,
  createDraft,
  autosaveDraft,
  loadLatestDraft,
  loadBatchContent,
} from "../../redux/actions/userActions";
import { connect } from "react-redux";
import { incrementAffiliateClicks } from "../../redux/actions/dataActions";
import RefreshAppPopUp from "../RefreshAppPopUp/RefreshAppPopUp";

import { makeStyles } from "tss-react/mui";
import ReferralsBlock from "../Referrals/ReferralsBlock";
import Dialog from "@mui/material/Dialog";
import { Typography } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

// Pages
import loginPage from "../../pages/login";
import signup from "../../pages/signup";
import forgotPassword from "../../pages/forgotPassword";
import profilePage from "../../pages/profile";
import user from "../../pages/user";
import postGenerator from "../../pages/postGenerator";
import privacyPolicy from "../../pages/privacyPolicy";
import termsAndConditions from "../../pages/termsAndConditions";
import contact from "../../pages/contact";
import pricing from "../../pages/pricing";
import home from "../../pages/home";
import scheduling from "../../pages/scheduling";
import singlePostGenerator from "../../pages/singlePostGenerator";
import singlePostGeneratorTest from "../../pages/singlePostGeneratorTest";
import affiliate from "../../pages/affiliate";
import foundingPartners from "../../pages/foundingPartners";
import foundingPartnersAcceptInvite from "../../pages/foundingPartnersAcceptInvite";
import foundingPartnersDashboard from "../../pages/foundingPartnersDashboard";
import featureRoadmap from "../../pages/featureRoadmap";
// import lifetime from "../../pages/lifetime";
import products from "../../pages/products";
// import redeemCode from "../../pages/redeemCode";
import templateBuilder from "../../pages/templateBuilder";
import templates from "../../pages/templates";
import blog from "../../pages/blog";
import singleBlog from "../../pages/singleBlog";
import singlePage from "../../pages/singlePage";
import {
  getUserTemplates,
  getStandardTemplates,
} from "../../redux/actions/templateActions";
import admin from "../../pages/admin";
import unsubscribe from "../../pages/unsubscribe";
import emailSignup from "../../pages/emailSignup";
import verifyEmail from "../../pages/verifyEmail";
import pageNotFound from "../../pages/pageNotFound";
import savingsCalculator from "../../pages/savingsCalculator";
import onboarding from "../../pages/onboarding";
import automate from "../../pages/automate";
import blogGenerator from "../../pages/blogGenerator";
import blogGeneratorDashboard from "../../pages/blogGeneratorDashboard";
import referral from "../../pages/referral";
import ContentGenerationLoading from "../ConnectedWebsites/ContentGenerationLoading";

// Get the app version from package.json
import packageJson from "../../../package.json";
const { version } = packageJson;

axios.defaults.baseURL = config.apiBaseURL;

const AppRoutes = () => (
  <div className="container">
    <Switch>
      {/* Auth routes */}
      <AuthRoute exact path="/login" component={loginPage} />
      <RouteWithOptionalNavElements
        exact
        path="/signup"
        component={signup}
        hasNavBar={true}
        hasFooter={true}
        hasPopUpDialog={false}
        hasCookiesConsent={false}
      />
      <AuthRoute exact path="/forgot-password" component={forgotPassword} />

      {/* Routes with NavBar elements */}
      <RouteWithNavElements exact path="/" component={home} />
      <RouteWithNavElements
        exact
        path="/backupGenerator"
        component={postGenerator}
      />
      <RouteWithNavElements exact path="/profile" component={profilePage} />
      <RouteWithNavElements exact path="/users/:handle" component={user} />
      <RouteWithNavElements
        exact
        path="/privacy-policy"
        component={privacyPolicy}
      />
      <RouteWithNavElements
        exact
        path="/terms-and-conditions"
        component={termsAndConditions}
      />
      <RouteWithNavElements exact path="/contact" component={contact} />
      <RouteWithNavElements exact path="/pricing" component={pricing} />
      <RouteWithNavElements exact path="/scheduling" component={scheduling} />
      <RouteWithNavElements exact path="/products" component={products} />
      <RouteWithNavElements exact path="/affiliate" component={affiliate} />
      <RouteWithNavElements
        exact
        path="/founding-partners"
        component={foundingPartners}
      />
      <RouteWithNavElements
        exact
        path="/founding-partners-accept-invite"
        component={foundingPartnersAcceptInvite}
      />
      <RouteWithNavElements
        exact
        path="/founding-partner-dashboard"
        component={foundingPartnersDashboard}
      />
      <RouteWithNavElements
        exact
        path="/feature-roadmap"
        component={featureRoadmap}
      />
      <RouteWithNavElements exact path="/templates" component={templates} />
      <RouteWithNavElements
        exact
        path="/template-builder"
        component={templates}
      />
      <RouteWithNavElements exact path="/blog" component={blog} />
      <RouteWithNavElements exact path="/blog/:slug" component={singleBlog} />
      {/* <RouteWithNavElements exact path="/page/:slug" component={singlePage} /> */}
      <RouteWithNavElements exact path="/admin" component={admin} />
      <RouteWithNavElements exact path="/unsubscribe" component={unsubscribe} />
      <RouteWithNavElements
        exact
        path="/email-signup"
        component={emailSignup}
      />
      {/* <RouteWithNavElements exact path="/lifetime" component={lifetime} /> */}
      <RouteWithNavElements
        exact
        path="/verify-email"
        component={verifyEmail}
      />
      <RouteWithNavElements
        exact
        path="/savings-calculator"
        component={savingsCalculator}
      />
      <RouteWithNavElements exact path={"/onboarding"} component={onboarding} />
      <RouteWithNavElements exact path={"/automate"} component={automate} />
      <RouteWithNavElements
        exact
        path="/blog-generator"
        component={blogGenerator}
      />
      <RouteWithNavElements
        exact
        path="/blog-generator/dashboard"
        component={blogGeneratorDashboard}
      />

      <RouteWithNavElements exact path="/referral" component={referral} />

      {/* Routes with optional NavBar elements */}
      <RouteWithOptionalNavElements
        exact
        path="/generate"
        component={postGenerator}
        hasNavBar={true}
        hasFooter={false}
        hasPopUpDialog={true}
        hasLaunchBanner={false}
        hasCookiesConsent={true}
      />
      <Route
        exact
        path="/generate/loading"
        component={ContentGenerationLoading}
      />
      <RouteWithOptionalNavElements
        exact
        path="/template-builder/:templateId"
        component={templateBuilder}
        hasNavBar={true}
        hasFooter={false}
        hasPopUpDialog={true}
        hasCookiesConsent={true}
      />

      {/* Routes without NavBar elements */}
      <Route
        exact
        path="/singlePostGenerator"
        component={singlePostGenerator}
      />
      <Route
        exact
        path="/singlePostGeneratorTest"
        component={singlePostGeneratorTest}
      />

      {/* 404 */}
      <RouteWithNavElements component={pageNotFound} />
    </Switch>
  </div>
);

function App(props) {
  const { store, location, routerContext } = props;

  // Track which batch IDs we've already attempted to load to prevent infinite loops
  const [loadedBatchIds, setLoadedBatchIds] = useState(new Set());
  const [appNeedsUpdate, setAppNeedsUpdate] = React.useState(false);
  const [showReferralsModal, setShowReferralsModal] = React.useState(false);

  // Refs for autosave — avoids stale closures in the interval/beforeunload callbacks
  const postsRef = useRef(props.posts);
  const authenticatedRef = useRef(props.authenticated);
  const lastSavedHashRef = useRef(null);

  useEffect(() => { postsRef.current = props.posts; }, [props.posts]);
  useEffect(() => { authenticatedRef.current = props.authenticated; }, [props.authenticated]);

  // Modal styles
  const useStyles = makeStyles()((theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      maxWidth: "90%",
      maxHeight: "90%",
      overflow: "auto",
      borderRadius: "8px",
    },
    referralsDiv: {
      padding: theme.spacing(2),
    },
    modalText: {
      marginBottom: theme.spacing(1),
    },
  }));

  const { classes } = useStyles();

  // Monitor usedPostCredits and show modal when it exceeds 20
  useEffect(() => {
    if (props.credentials && props.credentials.usedPostCredits >= 20) {
      // Check if the modal has already been shown in the last 21 days
      const lastShown = localStorage.getItem("referralsModalShown");

      if (lastShown) {
        const { date, shown } = JSON.parse(lastShown);
        const lastShownDate = new Date(date);
        const currentDate = new Date();
        const diffTime = Math.abs(currentDate - lastShownDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays < 21 && shown) {
          // Modal has been shown in the last 21 days, do not show it again
          return;
        }
      }

      setShowReferralsModal(true);
      // set a cookie in localstorage to track if the modal has been shown
      localStorage.setItem(
        "referralsModalShown",
        JSON.stringify({
          // Set date to 21 days ago
          date: new Date().toISOString(),
          shown: true,
        })
      );
    }
  }, [props.credentials?.usedPostCredits]);

  // Periodic autosave (every 2 minutes) + beforeunload safety net
  useEffect(() => {
    const hashPosts = (posts) => JSON.stringify(posts);

    const saveIfDirty = () => {
      if (!authenticatedRef.current || !postsRef.current || postsRef.current.length === 0) return;

      const currentHash = hashPosts(postsRef.current);
      if (currentHash === lastSavedHashRef.current) return; // nothing changed

      lastSavedHashRef.current = currentHash;
      store.dispatch(autosaveDraft(postsRef.current));
    };

    const interval = setInterval(saveIfDirty, 2 * 60 * 1000);

    const handleBeforeUnload = () => {
      saveIfDirty();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      clearInterval(interval);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    // Check Firebase token
    const token = localStorage.FBIdToken;
    if (token) {
      const decodedToken = jwtDecode(token);

      if (decodedToken.exp * 1000 < Date.now()) {
        props.refreshFBIdToken().catch((err) => {
          console.log("Failed to refresh FBIdToken: ", err);
        });
      } else {
        store.dispatch({ type: SET_AUTHENTICATED });
        axios.defaults.headers.common["Authorization"] = token;

        try {
          store.dispatch(getUserData());
          store.dispatch(getUserTemplates("None"));
        } catch (err) {
          console.log("Failed to get user data: ", err);
        }
      }
    }

    // Load standard templates for all users (authenticated and non-authenticated)
    // This ensures templates are available for features like adding blank posts
    store.dispatch(getStandardTemplates());

    // Pinterest tokens are now managed server-side - no client-side checks needed
  }, []);

  useEffect(() => {
    // Get query string params
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    // Check if we have a batchId parameter - load batch content regardless of existing posts
    if (params.batchId && props.designProfilesLoaded) {
      // Prevent infinite loops by checking if we've already attempted to load this batch
      if (loadedBatchIds.has(params.batchId)) {
        console.log(
          `⚠️ Batch ${params.batchId} already loaded, skipping to prevent infinite loop`
        );
        return;
      }

      console.log(`🎯 Loading batch content for batchId: ${params.batchId}`);

      // Mark this batch as being loaded
      setLoadedBatchIds((prev) => new Set([...prev, params.batchId]));

      // Set loading state immediately when we detect batchId
      store.dispatch({
        type: SET_BATCH_CONTENT_LOADING,
        payload: true,
      });
      store.dispatch(loadBatchContent(params.batchId)).catch((err) => {
        console.error(
          `❌ Failed to load batch content for ${params.batchId}:`,
          err.message || err
        );

        // Clear loading state on error
        store.dispatch({
          type: SET_BATCH_CONTENT_LOADING,
          payload: false,
        });

        // Only remove from loaded set for non-403 errors to prevent infinite loops
        // For 403 (unauthorized) errors, keep it in the set to prevent retries
        if (err.response && err.response.status === 403) {
          console.log(
            `🚫 Keeping batchId ${params.batchId} in loaded set due to 403 error to prevent infinite loop`
          );
        } else {
          // Remove from loaded set on other errors so it can be retried
          setLoadedBatchIds((prev) => {
            const newSet = new Set(prev);
            newSet.delete(params.batchId);
            return newSet;
          });
        }

        // Fallback to latest draft if batch loading fails (except for 403 errors)
        if (!err.response || err.response.status !== 403) {
          store.dispatch(loadLatestDraft());
        }
      });
    } else if (
      props.designProfilesLoaded &&
      props.posts.length == 0 &&
      !params.keyword // Don't load drafts if we are coming from a keyword search
    ) {
      // Normal behavior - load latest draft only if no posts exist and no batchId
      store.dispatch(loadLatestDraft());
    }
  }, [props.designProfilesLoaded, loadedBatchIds]);

  // Add affiliate tracking cookie
  useEffect(() => {
    // Get query string params
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if (params.pgref || params.cgref) {
      // add to tracking history and localstorage
      let expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 30);

      let newAffiliateTrackingToken = {
        affiliateID: params.pgref || params.cgref,
        expiryDate,
      };

      localStorage.setItem(
        "congenaffiliate",
        JSON.stringify(newAffiliateTrackingToken)
      );

      // Remove "congenreferral" cookie if it exists
      if (localStorage.getItem("congenreferral")) {
        localStorage.removeItem("congenreferral");
      }

      // Increment clicks on user profile
      props.incrementAffiliateClicks(params.pgref || params.cgref);
    }

    if (params.cgreferral) {
      // add to tracking history and localstorage
      let expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 30);

      let newAffiliateTrackingToken = {
        referralCode: params.cgreferral,
        expiryDate,
      };

      localStorage.setItem(
        "congenreferral",
        JSON.stringify(newAffiliateTrackingToken)
      );

      // Remove "congenaffiliate" cookie if it exists
      if (localStorage.getItem("congenaffiliate")) {
        localStorage.removeItem("congenaffiliate");
      }
    }
  }, []);

  // Load Google Analytics and Pinterest tracking scripts if user has consented
  useEffect(() => {
    if (
      props.cookiesConsent == true ||
      JSON.parse(localStorage.getItem("cookiesConsent")) == true
    ) {
      // Pinterest pageview event
      //pintrk("track", "pagevisit");
    }
  }, [props.cookiesConsent]);

  // Set axios interceptor to check app version
  axios.interceptors.response.use(
    (response) => {
      // compare this version with the header called x-version
      // if they are different, reload the page
      if (response && response.headers["x-version"]) {
        if (response.headers["x-version"] !== version) {
          setAppNeedsUpdate(true);
        } else {
          setAppNeedsUpdate(false);
        }
      }

      return response;
    },
    async function (error) {
      return Promise.reject(error);
    }
  );

  // Set axios interceptor to handle 401 and 403 errors
  // Response interceptor for API calls
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async function (error) {
      const originalRequest = error.config;
      // Check for any 403 coming back from the Firebase API
      // If we have a FBRefeshToken, try to refresh
      if (
        error.response &&
        error.response.status === 403 &&
        !originalRequest._retry &&
        localStorage.FBRefreshToken
      ) {
        originalRequest._retry = true;

        try {
          //console.log("Refreshing FBIDToken from response interceptor");
          await props.refreshFBIdToken();

          //console.log("Retrying request in inteceptor");
          let requestWithNewAuthToken = {};
          requestWithNewAuthToken = { ...originalRequest };

          requestWithNewAuthToken.headers.Authorization =
            localStorage.FBIdToken;

          // Retry the request with new credentials
          let retryRes = await axios.request(requestWithNewAuthToken);

          if (retryRes.status == 200) {
            // Return the new resopnse to the original promise chain
            return retryRes;
          } else {
            return Promise.reject(error);
          }
        } catch (e) {
          return Promise.reject(error);
        }
      }
      // If we get a 401 when trying to refreshPinterestAccessToken dont try to refresh again
      else if (
        error.response &&
        error.response.status == 401 &&
        originalRequest.url.includes(
          "/api/pinterestAPI/refreshPinterestAccessToken"
        ) &&
        !originalRequest._retry
      ) {
        return Promise.reject(error);
      }
      // Pinterest API 401 errors - redirect to re-auth since tokens are now managed server-side
      else if (
        error.response &&
        error.response.status == 401 &&
        originalRequest.url.includes("/pinterestAPI/") &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        // In Test mode the backend uses the Pinterest sandbox API with a short-lived
        // sandbox token. A 401 here means that token expired - the user's real (live)
        // Pinterest connection is still valid, so don't prompt them to reconnect.
        if (config.configName !== "Live") {
          console.warn(
            "401 on Pinterest function in Test mode - skipping reconnect prompt. " +
              "The sandbox token should auto-refresh; if this persists, connect a " +
              "Pinterest profile once while in Test mode to re-seed the sandbox token " +
              "(stored in Firestore at devConfig/pinterestSandboxToken)."
          );
          return Promise.reject(error);
        }

        console.log("401 on Pinterest function - redirecting to OAuth");

        // Extract username from error response if available
        const profileUsername = error.response?.data?.profileUsername;

        // Since tokens are now managed server-side, we need to re-authenticate
        const { startPinterestOAuth } = require("../../utils/utilityFunctions");
        startPinterestOAuth(true, profileUsername);

        // Return rejected promise to stop the request chain
        return Promise.reject(error);
      }
      // Interceptor to retry any schedule posts failure that occur due to a code 10 transaction failure
      else if (
        error.response &&
        error.response.status == 503 &&
        originalRequest.url.includes("/api/scheduling/schedulePost") &&
        !originalRequest._retry
      ) {
        // Flag the request as a retried
        originalRequest._retry = true;

        try {
          // Retry the request as is
          let retryRes = await axios.request(originalRequest);

          if (retryRes.status == 200) {
            // Return the new response to the original promise chain
            return retryRes;
          } else {
            return Promise.reject(error);
          }
        } catch (err) {
          return Promise.reject(error);
        }
      }
      // Retry any 500 errror that comes back from trying to render a template
      else if (
        error.response &&
        error.response.status == 500 &&
        originalRequest.url.includes(
          "/highMemLimitApi/scraping/renderTemplateImage"
        ) &&
        !originalRequest._retry
      ) {
        // Flag the request as a retried
        originalRequest._retry = true;

        try {
          // Retry the request as is
          let retryRes = await axios.request(originalRequest);

          if (retryRes.status == 200) {
            // Return the new response to the original promise chain
            return retryRes;
          } else {
            return Promise.reject(error);
          }
        } catch (err) {
          return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
  );

  return (
    <Provider store={store}>
      <div className="App" id="App">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(webApplicationSchema),
          }}
        />
        {location ? (
          <StaticRouter location={location} context={routerContext}>
            <AppRoutes />
          </StaticRouter>
        ) : (
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        )}
        {appNeedsUpdate && <RefreshAppPopUp />}
        <Dialog
          open={showReferralsModal}
          onClose={() => setShowReferralsModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <div className={classes.referralsDiv}>
            <div className={classes.modalText}>
              <Typography variant="h2">
                Love using Content Generator?
              </Typography>
              <Typography>
                Share the magic with a friend and get rewarded!
              </Typography>
            </div>
            <ReferralsBlock />
          </div>
          <DialogActions>
            <Button
              onClick={() => setShowReferralsModal(false)}
              color="primary"
            >
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Provider>
  );
}

const mapStateToProps = (state) => ({
  cookiesConsent: state.user.credentials.cookiesConsent,
  userTemplates: state.templates.present.userTemplates,
  standardTemplates: state.templates.present.standardTemplates,
  posts: state.design.posts,
  authenticated: state.user.authenticated,
  designProfilesLoaded: state.design.designProfilesLoaded,
  credentials: state.user.credentials,
  user: state.user,
});

export default connect(mapStateToProps, {
  validateFBIdToken,
  refreshFBIdToken,
  refreshPinterestAccessToken,
  incrementAffiliateClicks,
  softLogoutUser,
  createDraft,
  loadLatestDraft,
  loadBatchContent,
  getStandardTemplates,
})(App);
